import React from "react";

import Navbar from "../components/portfolio_page/nav_bar/nav_bar";
import PortfolioFrame from "../components/portfolio_page/portfolio/portfolio_tab/portfolio_tab_frame";
import Footer from "../components/portfolio_page/footer/footer";
import Greeting from "../components/portfolio_page/greeting/greeting";

const PortfolioTabContainer = () => {
  return (
    <>
      <Navbar />
      <Greeting />
      <PortfolioFrame />
      <Footer />
    </>
  )
}

export default PortfolioTabContainer;